import { Icon } from '../regureStyles';

const DataError = ({ t, dataError, fetchDashboard }) => {
  if (!dataError) return <></>;

  return (
    <div style={{ background: '#fef2f2', border: '1px solid #fca5a5', borderRadius: 10, padding: '12px 18px', display: 'flex', alignItems: 'center', gap: 10 }}>
      <Icon name='alert-circle' size={16} color='#ef4444' />
      <span style={{ fontSize: 13, color: '#991b1b', flex: 1 }}>{t('common.dataCouldNotBeLoaded')}</span>
      <button
        onClick={fetchDashboard}
        style={{ fontSize: 12, color: '#991b1b', background: 'none', border: 'none', cursor: 'pointer', fontWeight: 600, textDecoration: 'underline' }}
      >
        {t('common.retry')}
      </button>
    </div>
  );
};

export default DataError;
